/**
 * @generated SignedSource<<947f24df4bdb8f331d40d0a5bffa68fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type requestCareDetailUpdateMutation$variables = {
  addressdetail: string;
  caredetailid: number;
  desiredenddate: any;
  desiredstartdate: any;
  hospitalid: number;
  id: number;
  otherrequirement: string;
  patientname: string;
  recipientid?: string | null | undefined;
  requeststatus: number;
};
export type requestCareDetailUpdateMutation$data = {
  readonly update_insurance_request_log: {
    readonly affected_rows: number;
  } | null | undefined;
  readonly update_request_care_detail: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type requestCareDetailUpdateMutation = {
  response: requestCareDetailUpdateMutation$data;
  variables: requestCareDetailUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addressdetail"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "caredetailid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "desiredenddate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "desiredstartdate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hospitalid"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherrequirement"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientname"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientid"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requeststatus"
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "affected_rows",
    "storageKey": null
  }
],
v11 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "recipientid",
            "variableName": "recipientid"
          },
          {
            "kind": "Variable",
            "name": "requeststatus",
            "variableName": "requeststatus"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_log_mutation_response",
    "kind": "LinkedField",
    "name": "update_insurance_request_log",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "addressdetail",
            "variableName": "addressdetail"
          },
          {
            "kind": "Variable",
            "name": "desiredenddate",
            "variableName": "desiredenddate"
          },
          {
            "kind": "Variable",
            "name": "desiredstartdate",
            "variableName": "desiredstartdate"
          },
          {
            "kind": "Variable",
            "name": "hospitalid",
            "variableName": "hospitalid"
          },
          {
            "kind": "Variable",
            "name": "otherrequirement",
            "variableName": "otherrequirement"
          },
          {
            "kind": "Variable",
            "name": "patientname",
            "variableName": "patientname"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "caredetailid"
              }
            ],
            "kind": "ObjectValue",
            "name": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "request_care_detail_mutation_response",
    "kind": "LinkedField",
    "name": "update_request_care_detail",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "requestCareDetailUpdateMutation",
    "selections": (v11/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v8/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "requestCareDetailUpdateMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "d2c1cb4513be026696244a3e0efbd71e",
    "id": null,
    "metadata": {},
    "name": "requestCareDetailUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation requestCareDetailUpdateMutation(\n  $recipientid: String\n  $id: Int!\n  $caredetailid: Int!\n  $requeststatus: Int!\n  $hospitalid: Int!\n  $patientname: String!\n  $otherrequirement: String!\n  $desiredstartdate: timestamptz!\n  $desiredenddate: timestamptz!\n  $addressdetail: String!\n) {\n  update_insurance_request_log(where: {id: {_eq: $id}}, _set: {recipientid: $recipientid, requeststatus: $requeststatus}) {\n    affected_rows\n  }\n  update_request_care_detail(where: {id: {_eq: $caredetailid}}, _set: {hospitalid: $hospitalid, patientname: $patientname, otherrequirement: $otherrequirement, desiredstartdate: $desiredstartdate, desiredenddate: $desiredenddate, addressdetail: $addressdetail}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "69df5656bb811602e78bdaf57be0f87b";

export default node;
